import customAxios from '../utils/axiosConfig';
import { API_BASE_URL } from '../utils/config';

const BASE_URL = `${API_BASE_URL}/projects`;

export const getTableInfo = async () => {
  const response = await customAxios.get(`${BASE_URL}/get_table_info`);
  return response.data;
};

